const Rate = ({ id, logo, title, description, price, detailedDescription, onClick }) => {
    return (
      <div className="generic-container" style={{ cursor: "pointer" }} onClick={onClick}>
        <div className="generic-logo">
          <img src={logo} alt={title} loading="lazy"/>
        </div>
        <div className="generic-title">
          <h3>{title}</h3>
        </div>
        <div className="generic-separator" />
        <div className="generic-description rate-description">
          <p>{description}</p>
          <p style= {{color: "var(--primary-blue-color)"}}><em>{price}</em></p>
          <p style= {{color: "var(--primary-blue-color)"}}><em>{detailedDescription}</em></p>
        </div>
      </div>
    );
  };
  
  export default Rate;